import Cookie from 'js-cookie';

export const createStorage = storage => ({
  get(key) {
    return JSON.parse(storage.get(key) || null);
  },

  set(key, value, expires) {
    storage.set(key, JSON.stringify(value), { expires });
  },
});

export const cookieStorage = createStorage(Cookie);
